//
// Get media attachment locations (source : laravel config/attachment-locations.php
const configAttachments = window.config.attachments

export default Object.freeze(configAttachments)
